// Google reCAPTCHA v3 integration.
// Paste your v3 site key (public) below. The matching secret key is stored
// in the backend as RECAPTCHA_SECRET_KEY. If RECAPTCHA_SITE_KEY is empty,
// the frontend silently skips reCAPTCHA and other spam layers still run.
export const RECAPTCHA_SITE_KEY = "6LcN3CQtAAAAAPAyavE4FeB2UTXfjNZfmpuTRqQe";

declare global {
  interface Window {
    grecaptcha?: {
      ready: (cb: () => void) => void;
      execute: (siteKey: string, opts: { action: string }) => Promise<string>;
    };
  }
}

let loaderPromise: Promise<void> | null = null;

function loadScript(): Promise<void> {
  if (!RECAPTCHA_SITE_KEY) return Promise.resolve();
  if (typeof window === "undefined") return Promise.resolve();
  if (window.grecaptcha) return Promise.resolve();
  if (loaderPromise) return loaderPromise;
  loaderPromise = new Promise<void>((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("recaptcha_load_failed"));
    document.head.appendChild(s);
  });
  return loaderPromise;
}

export async function getRecaptchaToken(action: string): Promise<string | null> {
  if (!RECAPTCHA_SITE_KEY) return null;
  try {
    await loadScript();
    if (!window.grecaptcha) return null;
    return await new Promise<string>((resolve, reject) => {
      window.grecaptcha!.ready(async () => {
        try {
          const token = await window.grecaptcha!.execute(RECAPTCHA_SITE_KEY, { action });
          resolve(token);
        } catch (e) {
          reject(e);
        }
      });
    });
  } catch {
    return null;
  }
}
